import React from 'react';
import { FacebookLogo, InstagramLogo, TiktokLogo } from "@phosphor-icons/react";

// SEGURIDAD: Extraemos las variables con valores de respaldo (Fallback)
const TEL_PRINCIPAL = process.env.REACT_APP_WHATSAPP_NUMBER || "522282425769";
const TEL_ALT = process.env.REACT_APP_WHATSAPP_NUMBER_ALT || "2282155568";
const EMAIL = process.env.REACT_APP_EMAIL_CONTACTO || "ctexref@gmail.com";
const MSG_CRITICO = process.env.REACT_APP_WHATSAPP_MSG_CRITICO || "Hola, requiero la visita de un técnico especializado.";

const Footer = () => {

    const localClients = [
        { name: "Fogon do Brasil", logo: "/img/logos/fogonlogo.webp" },
        { name: "Merendero La Joya", logo: "/img/logos/lajoya.webp" },
        { name: "La Roma", logo: "/img/logos/RomaGrill.webp" },
        { name: "Quesería Morales", logo: "/img/logos/QueseriaMorales.webp" },
        { name: "Laboratorio CI-Lab", logo: "/img/logos/ICILAB.webp" },
        { name: "Shrimp Lighthouse", logo: "/img/logos/ShrimpLighthouse.webp" },
        { name: "Giot Gyot Xalapa", logo: "/img/logos/Guiot.webp" },
        { name: "Casino Wintop", logo: "/img/logos/WinpotCasino.webp" },
        { name: "La Ferre", logo: "/img/logos/Ferre.webp" },
        { name: "Aldo Conti", logo: "/img/logos/AldoConti.webp" },
        { name: "Bola de Oro", logo: "/img/logos/BolaDeOro.webp" }
    ];

    const majorBrands = [
        { name: "Oxxo", logo: "/img/logos/oxxologo.webp" },
        { name: "Coca-Cola", logo: "/img/logos/coca.webp" },
        { name: "FedEx", logo: "/img/logos/fedex.webp" },
        { name: "Tiendas Neto", logo: "/img/logos/TiendaNeto.webp" },
        { name: "Joyería Bizarro", logo: "/img/logos/logo_bizzarro.webp" },
        { name: "C4", logo: "/img/logos/c4.webp" },
        { name: "Metalfrio", logo: "/img/logos/Metalfrio-logo.webp" },
        { name: "Criotec", logo: "/img/logos/Criotec.webp" }
    ];

    const LogoGrid = ({ brands, title }) => (
        <div className="mb-12">
            <p className="text-center text-gray-500 uppercase tracking-[0.2em] text-[10px] mb-8 font-bold italic">
                {title}
            </p>
            <div className="flex flex-wrap justify-center items-center gap-6">
                {brands.map((brand, index) => (
                    <div key={index} className="bg-white/5 p-4 rounded-xl flex items-center justify-center w-32 h-20 md:w-48 md:h-28 border border-white/5 transition-all duration-300">
                        <img
                            src={brand.logo}
                            alt={brand.name}
                            title={brand.name}
                            loading="lazy"
                            className="max-h-full max-w-full object-contain transition-all duration-500"
                        />
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <footer id="contacto" className="bg-gray-900 text-white pt-12 pb-6 border-t-4 border-ctex-orange">
            <div className="container mx-auto px-4">

                <div className="pt-8 border-t border-gray-800">
                    <LogoGrid brands={localClients} title="Nuestros Clientes" />
                </div>

                <div className="mt-8">
                    <LogoGrid brands={majorBrands} title="Respaldo Técnico de Marcas" />
                </div>

                <div className="flex flex-col md:flex-row justify-between items-center gap-8 mt-16">
                    <div className="text-center md:text-left">
                        <h2 className="text-xl font-bold text-white mb-2 uppercase tracking-tighter italic">
                            CTEX <span className="text-ctex-orange font-light ml-2">Soluciones Técnicas</span>
                        </h2>

                        {/* Contacto Principal */}
                        <div className="flex flex-col sm:flex-row gap-x-8 gap-y-4 text-sm text-gray-400 justify-center md:justify-start items-center mb-6">
                            <p className="flex items-center gap-2">📞 <span className="text-gray-200">{TEL_PRINCIPAL}</span></p>
                            <p className="flex items-center gap-2">📞 <span className="text-gray-200">{TEL_ALT}</span></p>
                            <p className="flex items-center gap-2">📧 <span className="text-gray-200">{EMAIL}</span></p>
                        </div>

                        {/* Redes Sociales - SEGURIDAD: rel="noopener noreferrer" en todos */}
                        <div className="flex flex-wrap gap-6 justify-center md:justify-start items-center">
                            <a
                                href="https://www.facebook.com/share/1JrQLApWc6/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors"
                            >
                                <FacebookLogo size={24} weight="fill" />
                                <span className="font-bold text-xs uppercase">Facebook</span>
                            </a>

                            <a
                                href="https://www.instagram.com/ctex134?igsh=NmM2OGdmcDJ2M2gx"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 text-pink-500 hover:text-pink-400 transition-colors"
                            >
                                <InstagramLogo size={24} weight="fill" />
                                <span className="font-bold text-xs uppercase">Instagram</span>
                            </a>

                            <a
                                href="https://www.tiktok.com/@ctex0?_r=1&_t=ZS-93Jm18cTWzI"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 text-gray-200 hover:text-white transition-colors border-l border-gray-700 pl-6"
                            >
                                <TiktokLogo size={24} weight="fill" />
                                <span className="font-bold text-xs uppercase">TikTok</span>
                            </a>
                        </div>
                    </div>

                    <div className="flex flex-col items-center md:items-end">
                        <p className="text-red-500 text-[9px] font-black mb-4 tracking-[0.2em] uppercase flex items-center gap-2">
                            <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
                            Soporte Crítico 24/7
                        </p>
                        <a
                            href={`https://wa.me/${TEL_PRINCIPAL}?text=${encodeURIComponent(MSG_CRITICO)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-full text-[10px] uppercase transition-all shadow-lg hover:shadow-green-900/40 transform hover:-translate-y-1 active:scale-95"
                        >
                            Atención Inmediata
                        </a>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-gray-800/50 flex flex-col md:flex-row justify-between items-center gap-4 text-[8px] text-gray-600 uppercase tracking-[0.3em] text-center">
                    <p>© {new Date().getFullYear()} CTEX – Mantenimiento Integral, Equipo y Refacciones.</p>
                    <p>Todos los derechos reservados. COPYRIGHT.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;

